import React from 'react';
import PropTypes from 'prop-types';
import { StyledButtonGroup, StyledButtonWrapper } from './styled';

const ButtonGroup = ({ children, direction, gutters, customStyle }) => {
    return (
        <StyledButtonGroup
            direction={direction}
            gutters={gutters}
            customStyle={customStyle}
        >
            {
                React.Children.map(children, (child, index) => {
                    if(!child) return null;
                    return (
                        <StyledButtonWrapper key={index}>
                            {child}
                        </StyledButtonWrapper>
                    )
                })
            }
        </StyledButtonGroup>
    );
};

ButtonGroup.propTypes = {
    children: PropTypes.node,
    direction: PropTypes.oneOf(['row', 'column']),
    gutters: PropTypes.number,
    customStyle: PropTypes.array
};

ButtonGroup.defaultProps = {
    direction: 'row',
    gutters: 5
};


export default React.memo(ButtonGroup);
